import { useEffect } from "react";
import { useTranslation } from "react-i18next";
import { Route, Routes } from "react-router-dom";
import DowloadCenterTable from "./table";
import { setDocumentTitle } from "@/lib/documentTitle";
import { Clients } from "../../../lib/clients";

export default function G4DownloadCenter() {
  const { t, i18n } = useTranslation(["titles"]);

  useEffect(() => {
    setDocumentTitle(
      t("quantilia_download_center", {
        ns: "titles",
        defaultValue: "Quantilia | Download Center",
      }),
    );
  }, [t, i18n.language]);

  return (
    <Routes>
      <Route
        index
        element={
          <DowloadCenterTable
            client={Clients.G4}
            table_name={"g4_download_center"}
          />
        }
      />
    </Routes>
  );
}
